export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тип адреси"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тип рахунку"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Валюта"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Назва"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Створити адресу"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Створити рахунок"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Створення нової адреси"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Створити новий рахунок"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введіть назву"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Виберіть валюту"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Створити"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скасувати"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Виберіть тип"])}
}